module.exports = __webpack_public_path__ + "static/media/vibino-feature-blur photo-PIC1.ec595f2e.jpg";